import { AlertCircle, CheckCircle2 } from "lucide-react";

export function StatusBanner({
  error,
  successMsg,
}: {
  error?: string | null;
  successMsg?: string | null;
}) {
  return (
    <div
      className={`grid transition-all duration-300 ease-in-out ${
        error || successMsg
          ? "grid-rows-[1fr] opacity-100"
          : "grid-rows-[0fr] opacity-0"
      }`}
    >
      <div className="overflow-hidden">
        {(error || successMsg) && (
          <div
            className={`flex items-start gap-3 rounded-lg border p-3 ${
              error
                ? "border-red-200 bg-red-50 text-red-800"
                : "border-emerald-200 bg-emerald-50 text-emerald-800"
            }`}
          >
            <div className="mt-0.5 shrink-0">
              {error ? <AlertCircle size={16} /> : <CheckCircle2 size={16} />}
            </div>
            <p className="text-sm">{error ?? successMsg}</p>
          </div>
        )}
      </div>
    </div>
  );
}
